<template>

    <v-container>
        <v-row wrap class="justify-space-around mb-6 pl-1 pr-1 pl-sm-2 pr-sm-2 pl-md-16 pr-md-16">

            <v-col :cols="12" xl="6" lg="6" md="6" sm="10">
                <div class="no_verflow">
                    <v-card class="rounded-0 middle_img pa-6 pa-xs-0" >
                        <v-card-title class="newsTitle justify-center">{{news[newsmodel].title}}</v-card-title>
                        <v-card-text class="newsText" v-html="news[newsmodel].text"></v-card-text>
                    </v-card>
                    <div class="arrow_left">
                        <v-btn @click="newsmodel > 0 ? newsmodel-- : newsmodel = (news.length - 1);" icon color=#707070> 
                            <v-icon :size="getIconSizeLeft">fas fa-angle-left</v-icon>
                        </v-btn>
                    </div>
                    <div class="arrow_right">
                        <v-btn @click="newsmodel < news.length - 1 ? newsmodel++ : newsmodel = 0" class="arrowBtn" icon color=#1765B3>
                            <v-icon :size="getIconSize">fas fa-angle-right</v-icon>
                        </v-btn>
                    </div>

                </div>
            </v-col>
            <v-col class="hidden-sm-and-down" cols="10" xl="5" lg="5" md="4" sm="4">
                <v-img class="article_img"
                :src="news[newsmodel].images[0]"
                :style="{filter:'grayscale(100%)'}"
                v-prlx="{ 
                    custom: true,
                    limit: { min: 0, max: 30 }
                }" 
                >
                </v-img>
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: 'NewsCarousel',
        methods: {
           
        }, 
        
        computed: {
            getIconSize () {
                const {smAndDown } = this.$vuetify.breakpoint
                return smAndDown ? 80 : 130
            },
            getIconSizeLeft () {
                const {smAndDown } = this.$vuetify.breakpoint
                return smAndDown ? 70 : 95
            }
        },

        data() {
            return {
                newsmodel : 0,
                news : [
                    {
                        title : "Jazz in Times of Corona",
                        text : "<p>Weltweit sind die meisten Jazzclub ihrem Publikum nur noch durch live-Streams bekannt. Im New Yorker Birdland spielen die Musiker nur vor halb besetztem Haus, im Hamburger Pendant (z.Zt. noch geschlossen) durften einige JAZZTERDAYS Musiker ihre Songs vor Kameras aufführen. Trotz der Freude, endlich mal wieder „live“ gespielt zu haben – das sollte nicht zum Dauerzustand werden, befanden die meisten.</p>"
                                + "<p>Eine weitere Aufführung von JAZZTERDAYS in der Halle 424 war für Anfang November geplant und musste leider ausfallen. Wir hoffen auf einen baldigen Nachholtermin im Frühjahr. Weitere Auftritte für 2021 sind geplant, wenn sich das Konzertleben hoffentlich wieder normalisiert hat.</p>",
                        images  : ["/news/birdland1.jpg","/news/birdland2.jpg", "/news/birdland3.jpg"]
                    },
                    {
                        title : "Neue Story: Nica’s Dream	",
                        text : "<p>Ab sofort wird eine neue Story von Volker Präkelt das Programm bereichern. Im Mittelpunkt steht die legendäre „Jazz Baroness“ Pannonica.</p>"
                                + "<p>Baronin, Pilotin, Jazz-Mäzenin, vergnügungssüchtige Millionenerbin? Wer war Pannonica de Koenigswarter, geb. Rothschild, fünffache Mutter, die mit knapp vierzig nach New York zog und sich in Zeiten der Rassentrennung hingebungsvoll um Musiker der schwarzen Community kümmerte? Lieferte sie einen Beweis für Humanität oder wollte sie nur provozieren? Ging es um Liebe? Wie war ihre Beziehung zum genial-verrückten Pianisten Thelonious Monk? Warum suchte Charlie Parker kurz vor seinem Tod ausgerechnet ihr Apartment im Stanhope Hotel auf? Diesen Fragen geht die Geschichte nach, die sich an realen Fakten und Figuren orientiert und passende Songs wie „Round Midnight“ oder „Nica’s Dream“ erklingen lässt.</p>",
                        images  : ["/news/ny1.jpg"]
                    },
                ]
            }
        }
   
    }
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap');


    .newsTitle {
        text-align: justify;
        font-family: 'Teko', sans-serif;
        color: #707070;
        font-size: 1.7rem;

        @media #{map-get($display-breakpoints, 'xs-only')} {
            font-size: 1.5rem;
        }

    }
    .newsText {
        text-align: left;
        text-overflow: ellipsis;
        word-wrap: break-word;
    }

    .article_img {
        transform: scale(calc(calc(var(--parallax-value) / 70) + 0.5));
    }
    .repeating-gradient {
        background-image: repeating-linear-gradient(45deg,
                        rgba(55, 56, 58,.5),
                        rgba(44, 62, 80,.5) 5px,
                        rgba(23, 101, 179,.5) 5px,
                        rgba(23, 101, 179,.5) 10px
                      );
    }
    .middle_img  {
        box-shadow: -26px 29px 13px -6px rgba(0,0,0,0.6) !important;
        border: 1px solid #918e8986;
    }
    .arrow_left {
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
            display: inline-block;
            margin-top: 4rem;
            margin-right: 2rem;
        }
        @media #{map-get($display-breakpoints, 'md-and-up')} {
            position: relative;
            display: initial;
            top: 0rem;
            left: -60%;
        }
    }

    .arrow_right {
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
            margin-top: 4rem;
            display: inline-block;
        }
        @media #{map-get($display-breakpoints, 'md-and-up')} {
            position: relative;
            display: initial;
            top: -7rem;
            left: 60%;
        }
    }
    .no_verflow{
        // overflow: hidden;
        position: relative;
        bottom: -80px;
        margin-bottom: -200px;
    }
</style>